import ReactDOM from "react-dom/client";
import Workflow from "./pages/workflow/Workflow";
import styles from "./index.css?string";
import scssStyles from "./assets/scss/main.scss?string";
import workflowStyles from "./pages/workflow/styles.css?string";
import reactFlowStyles from "./pages/workflow/reactflow.css?string";
import {PortalContainerProvider} from "./contexts/PortalContainerContext";

declare global {
  interface Window {
    __flowBuilderIframeDoc: Document;
  }
}

const cssStyles = [styles, scssStyles, workflowStyles, reactFlowStyles];

export function mount(containerId: string) {
  const container = document.getElementById(containerId);
  if (!container || container.querySelector("iframe")) return;

  const iframe = document.createElement("iframe");
  iframe.src = "about:blank";
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.border = "none";
  iframe.style.display = "block";
  iframe.setAttribute("allow", "fullscreen; clipboard-read; clipboard-write");
  container.appendChild(iframe);

  // Wait until iframe document is fully ready
  const waitForIframeReady = () => {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc || iframeDoc.readyState !== "complete") {
      requestAnimationFrame(waitForIframeReady);
      return;
    }

    const styleText = cssStyles
      .map(style =>
        style instanceof CSSStyleSheet
          ? Array.from(style.cssRules)
              .map(r => r.cssText)
              .join("\n")
          : style,
      )
      .join("\n");

    // Inject styles into iframe
    const iframeStyleTag = iframeDoc.createElement("style");
    iframeStyleTag.textContent = styleText;
    iframeDoc.head.appendChild(iframeStyleTag);

    // Shadow DOM for modals/dropdowns
    let shadowPortalHost = document.getElementById("flowbuilder-portal-host");
    if (!shadowPortalHost) {
      shadowPortalHost = document.createElement("div");
      shadowPortalHost.id = "flowbuilder-portal-host";
      document.body.appendChild(shadowPortalHost);
    }
    const shadowRoot =
      shadowPortalHost.shadowRoot ||
      shadowPortalHost.attachShadow({mode: "open"});

    const portalStyleTag = document.createElement("style");
    const shadowScopedStyleText = styleText.replace(/:root/g, ":host");
    portalStyleTag.textContent = shadowScopedStyleText;
    shadowRoot.appendChild(portalStyleTag);

    const portalMountPoint = document.createElement("div");
    shadowRoot.appendChild(portalMountPoint);

    // Mount React inside iframe
    const mountPoint = iframeDoc.createElement("div");
    mountPoint.style.width = "100%";
    mountPoint.style.height = "100%";
    iframeDoc.body.appendChild(mountPoint);

    const root = ReactDOM.createRoot(mountPoint);
    window.__flowBuilderIframeDoc = iframeDoc;

    root.render(
      <PortalContainerProvider container={portalMountPoint}>
        <Workflow />
      </PortalContainerProvider>,
    );
  };

  waitForIframeReady();
}
